"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ordertimelimitconfigCreateApi = ordertimelimitconfigCreateApi;
exports.ordertimelimitconfigDeleteApi = ordertimelimitconfigDeleteApi;
exports.ordertimelimitconfigDetailApi = ordertimelimitconfigDetailApi;
exports.ordertimelimitconfigListApi = ordertimelimitconfigListApi;
exports.ordertimelimitconfigUpdateApi = ordertimelimitconfigUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ordertimelimitconfigCreateApi(data) {
  return (0, _request.default)({
    url: '/admin/orderTimeLimitConfig/save',
    method: 'POST',
    data: data
  });
}
function ordertimelimitconfigUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/orderTimeLimitConfig/update',
    method: 'POST',
    data: data
  });
}
function ordertimelimitconfigDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/orderTimeLimitConfig/info/".concat(id),
    method: 'GET'
  });
}
function ordertimelimitconfigDeleteApi(data) {
  return (0, _request.default)({
    url: "/admin/orderTimeLimitConfig/delete",
    method: 'get',
    params: data // 接收对象参数
  });
}
function ordertimelimitconfigListApi(params) {
  return (0, _request.default)({
    url: '/admin/orderTimeLimitConfig/list',
    method: 'GET',
    params: params
  });
}